import React, { useEffect, useState } from 'react';
import { getHelloMessage, getProducts } from '../services/apiCalls'
import { useTranslation } from 'react-i18next';

function Homepage() {
  const env = process.env.REACT_APP_ENV
  const { t } = useTranslation();

  const [message, setMessage] = useState('');
  // const [products, setProducts] = useState([]);

  useEffect(() => {
    getHelloMessage()
      .then(setMessage)
      .catch(err => {
        console.error('Failed to fetch hello message:', err);
      });
  }, []);

  useEffect(() => {
    getProducts()
      .then(result => {
        // console.log('Fetched Stripe products:', result);
        // setProducts(result);
      })
      .catch(err => {
        console.error('Failed to fetch stripe products message:', err);
      });
  }, [])

  return (
    <div style={{backgroundColor: 'gray'}}>
        {t('homepage')}
        <p>{message}</p>
        <p>env: {env}</p>
    </div>
  )
}

export default Homepage;